import type { ICanBrowseAutomationMarketplaceProps } from "../types/automation-marketplace";

// NOTE: NSAI-5273 / NSAI-7390 — whether the automation marketplace can be
// browsed here; the Agents Marketplace tab, the listings query and the global
// search gate all read it, on web and mobile. Two things the raw role payload
// does not say:
// - `marketplace_automation:write` implies `:read` on the server
//   (PERMISSION_IMPLIES), but the payload the clients receive is not expanded,
//   so a write-only curator must be let in explicitly, or they could not load
//   the listing they need to manage their own publication.
// - The marketplace is organization-only: the server rejects every marketplace
//   request from a personal project, whatever the role's wildcard covers.
// Same rule as `canBrowseAssistantMarketplace` (NSAI-5274).
export const canBrowseAutomationMarketplace = ({
  isPersonalProject,
  hasMarketplaceAutomationReadPermission,
  hasMarketplaceAutomationWritePermission,
}: ICanBrowseAutomationMarketplaceProps): boolean =>
  !isPersonalProject &&
  (hasMarketplaceAutomationReadPermission ||
    hasMarketplaceAutomationWritePermission);
